/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './clone-contract-dialog.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/forms';
import * as i5 from '@angular/cdk/scrolling';
import * as i6 from '@angular/cdk/overlay';
import * as i7 from '@angular/cdk/platform';
import * as i8 from '@angular/cdk/bidi';
import * as i9 from '@angular/common';
import * as i10 from '../../../../../../app/modules/utilities/components/clone-contract-dialog/clone-contract-dialog.component';
import * as i11 from '../../../../../../app/modules/airport/services/airport/airport.service';
import * as i12 from '../../../../../../app/modules/airline/services/airline/airline.service';
import * as i13 from '../../../../../../app/modules/contract/services/contract/contract.service';
import * as i14 from '../../../../../../app/modules/contract/services/contract-field-group/contract-field-group.service';
import * as i15 from '../../../../../../app/modules/contract/services/flight-schedule-service/flight-schedule.service';
import * as i16 from '../../../../../../app/modules/contract/services/flight-schedule-columns/flight-schedule-columns.service';
const styles_CloneContractDialogComponent:any[] = [i0.styles];
export const RenderType_CloneContractDialogComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CloneContractDialogComponent,data:{}});
function View_CloneContractDialogComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'md-option',
      [['class','mat-option'],['role','option']],[[1,'tabindex',0],[2,'mat-selected',
          (null as any)],[2,'mat-option-multiple',(null as any)],[2,'mat-active',(null as any)],
          [8,'id',0],[1,'aria-selected',0],[1,'aria-disabled',0],[2,'mat-option-disabled',
              (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],
      (_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1)._selectViaInteraction()) !== false);
          ad = (pd_0 && ad);
        }
        if (('keydown' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,1)._handleKeydown($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i2.View_MdOption_0,i2.RenderType_MdOption)),i1.ɵdid(1,49152,[[1,4]],0,i3.MdOption,
      [i1.ElementRef,i1.ChangeDetectorRef,[2,i3.MdOptgroup],[2,i3.MATERIAL_COMPATIBILITY_MODE]],
      {value:[0,'value']},(null as any)),i1.ɵdid(2,16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      (_l()(),i1.ɵted(3,0,['\n        ','\n      ']))],(_ck,_v) => {
    const currVal_8:any = _v.context.$implicit.id;
    _ck(_v,1,0,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,1).selected;
    const currVal_2:any = i1.ɵnov(_v,1).multiple;
    const currVal_3:any = i1.ɵnov(_v,1).active;
    const currVal_4:any = i1.ɵnov(_v,1).id;
    const currVal_5:any = i1.ɵnov(_v,1).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,1).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,1).disabled;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7);
    const currVal_9:any = _v.context.$implicit.name;
    _ck(_v,3,0,currVal_9);
  });
}
function View_CloneContractDialogComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),12,'md-select',
      [['class','mat-select'],['formControlName','Airline'],['placeholder','Airline'],
          ['role','listbox']],[[1,'tabindex',0],[1,'aria-label',0],[1,'aria-labelledby',
          0],[1,'aria-required',0],[1,'aria-disabled',0],[1,'aria-invalid',0],[1,'aria-owns',
          0],[1,'aria-multiselectable',0],[2,'mat-select-disabled',(null as any)],
          [2,'mat-select-invalid',(null as any)],[2,'mat-select-required',(null as any)],
          [2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
          [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
          'keydown'],[(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('keydown' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,4)._handleClosedKeydown($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,4)._onBlur()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i2.View_MdSelect_0,i2.RenderType_MdSelect)),i1.ɵdid(1,16384,(null as any),
      0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(2,671744,(null as any),0,i4.FormControlName,[[3,i4.ControlContainer],
      [8,(null as any)],[8,(null as any)],[8,(null as any)]],{name:[0,'name']},(null as any)),
      i1.ɵprd(2048,(null as any),i4.NgControl,(null as any),[i4.FormControlName]),
      i1.ɵdid(4,1294336,(null as any),3,i3.MdSelect,[i5.ViewportRuler,i1.ChangeDetectorRef,
          i6.Overlay,i7.Platform,i1.Renderer2,i1.ElementRef,[2,i8.Directionality],
          [2,i4.NgForm],[2,i4.FormGroupDirective],[2,i4.NgControl],[8,(null as any)],
          [2,i3.MD_PLACEHOLDER_GLOBAL_OPTIONS],i3.MD_SELECT_SCROLL_STRATEGY],{placeholder:[0,
          'placeholder']},(null as any)),i1.ɵqud(603979776,1,{options:1}),i1.ɵqud(603979776,
          2,{optionGroups:1}),i1.ɵqud(335544320,3,{customTrigger:0}),i1.ɵdid(8,16384,
          (null as any),0,i4.NgControlStatus,[i4.NgControl],(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,1,['\n      '])),(_l()(),i1.ɵand(16777216,(null as any),1,
          1,(null as any),View_CloneContractDialogComponent_2)),i1.ɵdid(11,802816,
          (null as any),0,i9.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,1,['\n    ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_18:any = 'Airline';
        _ck(_v,2,0,currVal_18);
        const currVal_19:any = 'Airline';
        _ck(_v,4,0,currVal_19);
        const currVal_20:any = _co.airlineOptions;
        _ck(_v,11,0,currVal_20);
      },(_ck,_v) => {
        const currVal_0:any = i1.ɵnov(_v,4).tabIndex;
        const currVal_1:any = i1.ɵnov(_v,4)._ariaLabel;
        const currVal_2:any = i1.ɵnov(_v,4).ariaLabelledby;
        const currVal_3:any = i1.ɵnov(_v,4).required.toString();
        const currVal_4:any = i1.ɵnov(_v,4).disabled.toString();
        const currVal_5:any = i1.ɵnov(_v,4)._isErrorState();
        const currVal_6:any = i1.ɵnov(_v,4)._optionIds;
        const currVal_7:any = i1.ɵnov(_v,4).multiple;
        const currVal_8:any = i1.ɵnov(_v,4).disabled;
        const currVal_9:any = i1.ɵnov(_v,4)._isErrorState();
        const currVal_10:any = i1.ɵnov(_v,4).required;
        const currVal_11:any = i1.ɵnov(_v,8).ngClassUntouched;
        const currVal_12:any = i1.ɵnov(_v,8).ngClassTouched;
        const currVal_13:any = i1.ɵnov(_v,8).ngClassPristine;
        const currVal_14:any = i1.ɵnov(_v,8).ngClassDirty;
        const currVal_15:any = i1.ɵnov(_v,8).ngClassValid;
        const currVal_16:any = i1.ɵnov(_v,8).ngClassInvalid;
        const currVal_17:any = i1.ɵnov(_v,8).ngClassPending;
        _ck(_v,0,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
            currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,
            currVal_14,currVal_15,currVal_16,currVal_17]);
      });
}
function View_CloneContractDialogComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'md-option',
      [['class','mat-option'],['role','option']],[[1,'tabindex',0],[2,'mat-selected',
          (null as any)],[2,'mat-option-multiple',(null as any)],[2,'mat-active',(null as any)],
          [8,'id',0],[1,'aria-selected',0],[1,'aria-disabled',0],[2,'mat-option-disabled',
              (null as any)]],[[(null as any),'click'],[(null as any),'keydown']],
      (_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1)._selectViaInteraction()) !== false);
          ad = (pd_0 && ad);
        }
        if (('keydown' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,1)._handleKeydown($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i2.View_MdOption_0,i2.RenderType_MdOption)),i1.ɵdid(1,49152,[[4,4]],0,i3.MdOption,
      [i1.ElementRef,i1.ChangeDetectorRef,[2,i3.MdOptgroup],[2,i3.MATERIAL_COMPATIBILITY_MODE]],
      {value:[0,'value']},(null as any)),i1.ɵdid(2,16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      (_l()(),i1.ɵted(3,0,['\n        ','\n      ']))],(_ck,_v) => {
    const currVal_8:any = _v.context.$implicit.id;
    _ck(_v,1,0,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1)._getTabIndex();
    const currVal_1:any = i1.ɵnov(_v,1).selected;
    const currVal_2:any = i1.ɵnov(_v,1).multiple;
    const currVal_3:any = i1.ɵnov(_v,1).active;
    const currVal_4:any = i1.ɵnov(_v,1).id;
    const currVal_5:any = i1.ɵnov(_v,1).selected.toString();
    const currVal_6:any = i1.ɵnov(_v,1).disabled.toString();
    const currVal_7:any = i1.ɵnov(_v,1).disabled;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7);
    const currVal_9:any = _v.context.$implicit.name;
    _ck(_v,3,0,currVal_9);
  });
}
function View_CloneContractDialogComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),12,'md-select',
      [['class','mat-select'],['formControlName','Airport'],['placeholder','Airport'],
          ['role','listbox']],[[1,'tabindex',0],[1,'aria-label',0],[1,'aria-labelledby',
          0],[1,'aria-required',0],[1,'aria-disabled',0],[1,'aria-invalid',0],[1,'aria-owns',
          0],[1,'aria-multiselectable',0],[2,'mat-select-disabled',(null as any)],
          [2,'mat-select-invalid',(null as any)],[2,'mat-select-required',(null as any)],
          [2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
          [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
          'keydown'],[(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('keydown' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,4)._handleClosedKeydown($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,4)._onBlur()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i2.View_MdSelect_0,i2.RenderType_MdSelect)),i1.ɵdid(1,16384,(null as any),
      0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(2,671744,(null as any),0,i4.FormControlName,[[3,i4.ControlContainer],
      [8,(null as any)],[8,(null as any)],[8,(null as any)]],{name:[0,'name']},(null as any)),
      i1.ɵprd(2048,(null as any),i4.NgControl,(null as any),[i4.FormControlName]),
      i1.ɵdid(4,1294336,(null as any),3,i3.MdSelect,[i5.ViewportRuler,i1.ChangeDetectorRef,
          i6.Overlay,i7.Platform,i1.Renderer2,i1.ElementRef,[2,i8.Directionality],
          [2,i4.NgForm],[2,i4.FormGroupDirective],[2,i4.NgControl],[8,(null as any)],
          [2,i3.MD_PLACEHOLDER_GLOBAL_OPTIONS],i3.MD_SELECT_SCROLL_STRATEGY],{placeholder:[0,
          'placeholder']},(null as any)),i1.ɵqud(603979776,4,{options:1}),i1.ɵqud(603979776,
          5,{optionGroups:1}),i1.ɵqud(335544320,6,{customTrigger:0}),i1.ɵdid(8,16384,
          (null as any),0,i4.NgControlStatus,[i4.NgControl],(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,1,['\n      '])),(_l()(),i1.ɵand(16777216,(null as any),1,
          1,(null as any),View_CloneContractDialogComponent_4)),i1.ɵdid(11,802816,
          (null as any),0,i9.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,1,['\n    ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_18:any = 'Airport';
        _ck(_v,2,0,currVal_18);
        const currVal_19:any = 'Airport';
        _ck(_v,4,0,currVal_19);
        const currVal_20:any = _co.airportOptions;
        _ck(_v,11,0,currVal_20);
      },(_ck,_v) => {
        const currVal_0:any = i1.ɵnov(_v,4).tabIndex;
        const currVal_1:any = i1.ɵnov(_v,4)._ariaLabel;
        const currVal_2:any = i1.ɵnov(_v,4).ariaLabelledby;
        const currVal_3:any = i1.ɵnov(_v,4).required.toString();
        const currVal_4:any = i1.ɵnov(_v,4).disabled.toString();
        const currVal_5:any = i1.ɵnov(_v,4)._isErrorState();
        const currVal_6:any = i1.ɵnov(_v,4)._optionIds;
        const currVal_7:any = i1.ɵnov(_v,4).multiple;
        const currVal_8:any = i1.ɵnov(_v,4).disabled;
        const currVal_9:any = i1.ɵnov(_v,4)._isErrorState();
        const currVal_10:any = i1.ɵnov(_v,4).required;
        const currVal_11:any = i1.ɵnov(_v,8).ngClassUntouched;
        const currVal_12:any = i1.ɵnov(_v,8).ngClassTouched;
        const currVal_13:any = i1.ɵnov(_v,8).ngClassPristine;
        const currVal_14:any = i1.ɵnov(_v,8).ngClassDirty;
        const currVal_15:any = i1.ɵnov(_v,8).ngClassValid;
        const currVal_16:any = i1.ɵnov(_v,8).ngClassInvalid;
        const currVal_17:any = i1.ɵnov(_v,8).ngClassPending;
        _ck(_v,0,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
            currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,
            currVal_14,currVal_15,currVal_16,currVal_17]);
      });
}
export function View_CloneContractDialogComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'h1',[['class',
      'mat-dialog-title'],['md-dialog-title','']],[[8,'id',0]],(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(1,81920,(null as any),0,i3.MdDialogTitle,
      [[2,i3.MdDialogContainer]],(null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['Clone Contract'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(4,
      0,(null as any),(null as any),16,'md-dialog-content',[['class','mat-dialog-content']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(5,
      16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(6,16384,(null as any),
      0,i3.MdDialogContent,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(-1,
      (null as any),['\n  '])),(_l()(),i1.ɵeld(8,0,(null as any),(null as any),11,
      'form',[['novalidate','']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
          (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
          [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
              (null as any)]],[[(null as any),'submit'],[(null as any),'reset']],(_v,
          en,$event) => {
        var ad:boolean = true;
        var _co:i10.CloneContractDialogComponent = _v.component;
        if (('submit' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,10).onSubmit($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('reset' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,10).onReset()) !== false);
          ad = (pd_1 && ad);
        }
        if (('submit' === en)) {
          const pd_2:any = ((<any>_co.onSubmit()) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(9,16384,(null as any),0,i4.ɵbf,([] as any[]),
      (null as any),(null as any)),i1.ɵdid(10,540672,(null as any),0,i4.FormGroupDirective,
      [[8,(null as any)],[8,(null as any)]],{form:[0,'form']},(null as any)),i1.ɵprd(2048,
      (null as any),i4.ControlContainer,(null as any),[i4.FormGroupDirective]),i1.ɵdid(12,
      16384,(null as any),0,i4.NgControlStatusGroup,[i4.ControlContainer],(null as any),
      (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_CloneContractDialogComponent_1)),
      i1.ɵdid(15,16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CloneContractDialogComponent_3)),
      i1.ɵdid(18,16384,(null as any),0,i9.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵeld(22,0,(null as any),(null as any),15,'div',[['class','mat-dialog-actions'],
          ['md-dialog-actions','']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(23,16384,(null as any),0,i3.MdDialogActions,([] as any[]),
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵeld(25,0,(null as any),(null as any),5,'button',[['class','mat-raised-button'],
          ['md-dialog-close','cancel'],['md-raised-button',''],['type','button']],
          [[8,'disabled',0],[1,'aria-label',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,29).dialogRef.close(i1.ɵnov(_v,29).dialogResult)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(26,16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(27,180224,(null as any),0,i3.MdButton,
          [i1.Renderer2,i1.ElementRef,i7.Platform,i3.FocusOriginMonitor],(null as any),
          (null as any)),i1.ɵdid(28,16384,(null as any),0,i3.MdRaisedButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(29,540672,(null as any),
          0,i3.MdDialogClose,[i3.MdDialogRef],{dialogResult:[0,'dialogResult']},(null as any)),
      (_l()(),i1.ɵted(-1,0,['CANCEL'])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵeld(32,0,(null as any),(null as any),4,'button',[['class','mat-raised-button'],
          ['color','accent'],['md-raised-button',''],['type','submit']],[[8,'disabled',
          0]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i10.CloneContractDialogComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.onSubmit()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(33,16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(34,180224,(null as any),0,i3.MdButton,
          [i1.Renderer2,i1.ElementRef,i7.Platform,i3.FocusOriginMonitor],{disabled:[0,
              'disabled'],color:[1,'color']},(null as any)),i1.ɵdid(35,16384,(null as any),
          0,i3.MdRaisedButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,0,['COPY\n  '])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i10.CloneContractDialogComponent = _v.component;
    _ck(_v,1,0);
    const currVal_8:any = _co.coneContractForm;
    _ck(_v,10,0,currVal_8);
    const currVal_9:any = (_co.airlineOptions.length > 0);
    _ck(_v,15,0,currVal_9);
    const currVal_10:any = (_co.airportOptions.length > 0);
    _ck(_v,18,0,currVal_10);
    const currVal_13:any = 'cancel';
    _ck(_v,29,0,currVal_13);
    const currVal_15:boolean = !_co.coneContractForm.valid;
    const currVal_16:any = 'accent';
    _ck(_v,34,0,currVal_15,currVal_16);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).id;
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = i1.ɵnov(_v,12).ngClassUntouched;
    const currVal_2:any = i1.ɵnov(_v,12).ngClassTouched;
    const currVal_3:any = i1.ɵnov(_v,12).ngClassPristine;
    const currVal_4:any = i1.ɵnov(_v,12).ngClassDirty;
    const currVal_5:any = i1.ɵnov(_v,12).ngClassValid;
    const currVal_6:any = i1.ɵnov(_v,12).ngClassInvalid;
    const currVal_7:any = i1.ɵnov(_v,12).ngClassPending;
    _ck(_v,8,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
    const currVal_11:any = (i1.ɵnov(_v,27).disabled || (null as any));
    const currVal_12:any = i1.ɵnov(_v,29).ariaLabel;
    _ck(_v,25,0,currVal_11,currVal_12);
    const currVal_14:any = (i1.ɵnov(_v,34).disabled || (null as any));
    _ck(_v,32,0,currVal_14);
  });
}
export function View_CloneContractDialogComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-clone-contract-dialog',
      ([] as any[]),(null as any),(null as any),(null as any),View_CloneContractDialogComponent_0,
      RenderType_CloneContractDialogComponent)),i1.ɵdid(1,114688,(null as any),0,i10.CloneContractDialogComponent,
      [i3.MdDialogRef,i3.MD_DIALOG_DATA,i4.FormBuilder,i11.AirportService,i12.AirlineService,
          i13.ContractService,i14.ContractFieldGroupService,i15.FlightScheduleService,
          i16.FlightScheduleColumnsService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CloneContractDialogComponentNgFactory:i1.ComponentFactory<i10.CloneContractDialogComponent> = i1.ɵccf('app-clone-contract-dialog',
    i10.CloneContractDialogComponent,View_CloneContractDialogComponent_Host_0,{},{},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL3V0aWxpdGllcy9jb21wb25lbnRzL2Nsb25lLWNvbnRyYWN0LWRpYWxvZy9jbG9uZS1jb250cmFjdC1kaWFsb2cuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL3V0aWxpdGllcy9jb21wb25lbnRzL2Nsb25lLWNvbnRyYWN0LWRpYWxvZy9jbG9uZS1jb250cmFjdC1kaWFsb2cuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL3d3dy9kbmF0YS1jZXJmLWZyb250LWVuZC9yZWxlYXNlcy8yMDIwMDMyNjE2MTIzMy9zcmMvYXBwL21vZHVsZXMvdXRpbGl0aWVzL2NvbXBvbmVudHMvY2xvbmUtY29udHJhY3QtZGlhbG9nL2Nsb25lLWNvbnRyYWN0LWRpYWxvZy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL3V0aWxpdGllcy9jb21wb25lbnRzL2Nsb25lLWNvbnRyYWN0LWRpYWxvZy9jbG9uZS1jb250cmFjdC1kaWFsb2cuY29tcG9uZW50LnRzLkNsb25lQ29udHJhY3REaWFsb2dDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8aDEgbWQtZGlhbG9nLXRpdGxlPkNsb25lIENvbnRyYWN0PC9oMT5cbjxtZC1kaWFsb2ctY29udGVudD5cbiAgPGZvcm1cbiAgICAoc3VibWl0KT1cIm9uU3VibWl0KClcIlxuICAgIFtmb3JtR3JvdXBdPVwiY29uZUNvbnRyYWN0Rm9ybVwiPlxuICAgIDxtZC1zZWxlY3RcbiAgICAgICpuZ0lmPVwiYWlybGluZU9wdGlvbnMubGVuZ3RoID4gMFwiXG4gICAgICBwbGFjZWhvbGRlcj1cIkFpcmxpbmVcIlxuICAgICAgZm9ybUNvbnRyb2xOYW1lPVwiQWlybGluZVwiPlxuICAgICAgPG1kLW9wdGlvblxuICAgICAgICAqbmdGb3I9XCJsZXQgb3B0aW9uIG9mIGFpcmxpbmVPcHRpb25zXCJcbiAgICAgICAgW3ZhbHVlXT1cIm9wdGlvbi5pZFwiPlxuICAgICAgICB7eyBvcHRpb24ubmFtZSB9fVxuICAgICAgPC9tZC1vcHRpb24+XG4gICAgPC9tZC1zZWxlY3Q+XG5cbiAgICA8bWQtc2VsZWN0XG4gICAgICAqbmdJZj1cImFpcnBvcnRPcHRpb25zLmxlbmd0aCA+IDBcIlxuICAgICAgcGxhY2Vob2xkZXI9XCJBaXJwb3J0XCJcbiAgICAgIGZvcm1Db250cm9sTmFtZT1cIkFpcnBvcnRcIj5cbiAgICAgIDxtZC1vcHRpb25cbiAgICAgICAgKm5nRm9yPVwibGV0IG9wdGlvbiBvZiBhaXJwb3J0T3B0aW9uc1wiXG4gICAgICAgIFt2YWx1ZV09XCJvcHRpb24uaWRcIj5cbiAgICAgICAge3sgb3B0aW9uLm5hbWUgfX1cbiAgICAgIDwvbWQtb3B0aW9uPlxuICAgIDwvbWQtc2VsZWN0PlxuICA8L2Zvcm0+XG48L21kLWRpYWxvZy1jb250ZW50PlxuPGRpdiBtZC1kaWFsb2ctYWN0aW9ucz5cbiAgPGJ1dHRvbiBtZC1yYWlzZWQtYnV0dG9uIG1kLWRpYWxvZy1jbG9zZT1cImNhbmNlbFwiPkNBTkNFTDwvYnV0dG9uPlxuICA8YnV0dG9uXG4gICAgbWQtcmFpc2VkLWJ1dHRvblxuICAgIGNvbG9yPVwiYWNjZW50XCJcbiAgICB0eXBlPVwic3VibWl0XCJcbiAgICAoY2xpY2spPVwib25TdWJtaXQoKVwiXG4gICAgW2Rpc2FibGVkXT1cIiFjb25lQ29udHJhY3RGb3JtLnZhbGlkXCI+Q09QWVxuICA8L2J1dHRvbj5cbjwvZGl2PlxuIiwiPGFwcC1jbG9uZS1jb250cmFjdC1kaWFsb2c+PC9hcHAtY2xvbmUtY29udHJhY3QtZGlhbG9nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ1NNO01BQUE7VUFBQTtVQUFBO2NBQUE7TUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO01BQUEscURBQUE7TUFBQTtNQUFBLDBDQUFBO01BQUE7TUFFc0I7SUFBcEI7SUFGRixXQUVFLFNBRkY7O0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUE7UUFBQSxTQUFBO0lBRXNCO0lBQUE7Ozs7b0JBTnhCO01BQUE7VUFBQTtVQUFBO1VBQUE7VUFBQTtVQUFBO2NBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7TUFBQSxxREFBQTtNQUFBO01BQUEsc0JBQUE7TUFBQTthQUFBO2FBQUE7NERBQUE7VUFBQTtVQUFBO1VBQUE7VUFBQSxrRUFBQTtVQUFBO01BRzRCLG9DQUMxQjtVQUFBLDZEQUFBO1VBQUE7VUFBQSx1Q0FJWTs7O1FBTFo7UUFIRixXQUdFLFVBSEY7UUFFRTtRQUZGLFdBRUUsVUFGRjtRQUtJO1FBREYsWUFDRSxVQURGOztRQUpGO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBLFlBQUE7WUFBQSx5Q0FBQTtZQUFBLDJDQUFBOzs7O29CQWVFO01BQUE7VUFBQTtVQUFBO2NBQUE7TUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO01BQUEscURBQUE7TUFBQTtNQUFBLDBDQUFBO01BQUE7TUFFc0I7SUFBcEI7SUFGRixXQUVFLFNBRkY7O0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUE7UUFBQSxTQUFBO0lBRXNCO0lBQUE7Ozs7b0JBTnhCO01BQUE7VUFBQTtVQUFBO1VBQUE7VUFBQTtVQUFBO2NBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7TUFBQSxxREFBQTtNQUFBO01BQUEsc0JBQUE7TUFBQTthQUFBO2FBQUE7NERBQUE7VUFBQTtVQUFBO1VBQUE7VUFBQSxrRUFBQTtVQUFBO01BRzRCLG9DQUMxQjtVQUFBLDZEQUFBO1VBQUE7VUFBQSx1Q0FJWTs7O1FBTFo7UUFIRixXQUdFLFVBSEY7UUFFRTtRQUZGLFdBRUUsVUFGRjtRQUtJO1FBREYsWUFDRSxVQURGOztRQUpGO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBO1FBQUE7UUFBQTtRQUFBLFlBQUE7WUFBQSx5Q0FBQTtZQUFBLDJDQUFBOzs7O29CQWhCSjtNQUFBO01BQUEscUNBQUE7TUFBQSx3REFBb0I7TUFBQSxxQkFBbUIsMENBQ3ZDO01BQUE7TUFBQSwrRUFBQTtNQUFBO3VCQUFBLHNDQUFBO01BQUEsZ0VBQW1CO01BQUEseUJBQ2pCO01BQUE7VUFBQTtVQUFBO2NBQUE7bUJBQUE7UUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUNFO1VBQUE7VUFBQTtRQUFBO1FBREY7TUFBQSx1Q0FBQTtNQUFBLG9DQUFBO01BQUEsOEVBQUE7TUFBQSxnRkFBQTtNQUFBO01BQUEsZUFFaUMsOENBQy9CO01BQUE7YUFBQTtVQUFBLGlDQVNZO01BRVo7YUFBQTtVQUFBLGlDQVNZO01BQ1AsMENBQ1c7TUFDcEI7VUFBQTtVQUFBLHVCQUFBO1VBQUEsNkJBQXVCO01BQ3JCO1VBQUE7VUFBQTtZQUFBO1lBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtVQUFBLHFEQUFBO1VBQUE7VUFBQSxvQ0FBQTtVQUFBO1VBQUEsc0JBQUE7VUFBQSxrREFBQTtVQUFBO01BQWtELGtDQUFlO01BQ2pFO1VBQUE7VUFBQTtRQUFBO1FBQUE7UUFJRTtVQUFBO1VBQUE7UUFBQTtRQUpGO01BQUEscURBQUE7VUFBQTtVQUFBLG9DQUFBO1VBQUE7Y0FBQSxxREFBQTtVQUFBO01BS3VDLG9DQUM5QjtNQUNMOztJQXJDTjtJQUlJO0lBRkYsWUFFRSxTQUZGO0lBSUk7SUFERixZQUNFLFNBREY7SUFZRTtJQURGLFlBQ0UsVUFERjtJQWF1QjtJQUF6QixZQUF5QixVQUF6QjtJQU1FO0lBSEE7SUFGRixZQUtFLFdBSEEsVUFGRjs7SUE5QkY7SUFBQSxXQUFBLFNBQUE7SUFFRTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFdBQUEscUVBQUE7SUEyQkE7SUFBQTtJQUFBLFlBQUEsV0FBQSxVQUFBO0lBQ0E7SUFBQSxZQUFBLFVBQUE7Ozs7b0JDOUJGO01BQUE7NkNBQUEsVUFBQTtNQUFBOzswQ0FBQTtJQUFBOzs7OzsifQ==



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/utilities/components/clone-contract-dialog/clone-contract-dialog.component.ngfactory.ts